import React from "react";

import { bodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  const conditionCount = node.filter_group?.filters?.length;

  return (
    <div style={bodyTextStyle}>
      {conditionCount ? (
        `on ${conditionCount} condition${conditionCount > 1 ? "s" : ""}`
      ) : (
        "No conditions: evaluates to false"
      )}
    </div>
  );
};
